import React from 'react';
import { TimeSlot } from '../types/BookingTypes';

interface SchedulePickerProps {
  dates: string[];
  selectedDate: string;
  onDateSelect: (date: string) => void;
  timeSlots: TimeSlot[];
  selectedTimeSlot: TimeSlot | null;
  onTimeSlotSelect: (slot: TimeSlot) => void;
}

const SchedulePicker: React.FC<SchedulePickerProps> = ({ dates, selectedDate, onDateSelect, timeSlots, selectedTimeSlot, onTimeSlotSelect }) => {
  return (
    <div>
      <div className="flex gap-2 mb-4 overflow-x-auto">
        {dates.map(date => (
          <button
            key={date}
            className={`px-4 py-2 rounded ${selectedDate === date ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => onDateSelect(date)}
          >
            {date}
          </button>
        ))}
      </div>
      <div className="flex gap-2 flex-wrap">
        {timeSlots.map(slot => (
          <button
            key={slot.id}
            className={`px-4 py-2 rounded ${!slot.available ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : selectedTimeSlot?.id === slot.id ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => slot.available && onTimeSlotSelect(slot)}
            disabled={!slot.available}
          >
            {slot.time}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SchedulePicker; 